import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
class AgendaSideBarDatepicker extends Vue {

  dtDate: any | null;
  /**
   *
   */
  constructor() {
    super();
    this.dtDate = null;
  }
  @Prop({ default: () => [], type: [Array] })
  dots: string[];

  get coLocale(): string {
    return this.$i18n.locale
  }
  get eventDotsDate(): string[] {
    return this.dots;
  }

  @Emit('change')
  handleDateChange(event) { }
}

export default AgendaSideBarDatepicker;


// WEBPACK FOOTER //
// ./src/containers/agenda/components/agenda-sidebar-date-picker/index.ts